import React from 'react';
import { useTranslation } from 'react-i18next';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { NavLink } from 'react-router-dom';
import polishGermanIcon from '../../assets/icons/polish-german-icon.svg';
import FontAwesome from '../uiStyle/FontAwesome';

/**
 * Dropdown Component
 * Renders a list of navigation menu items with specific handling for "suchportal" and "angebote".
 */
const Dropdown = ({ menus }) => {
    const { t } = useTranslation();

    // Extract the "suchportal" item and separate it from other menu items
    const suchportalItem = menus.find(
        (item) => item.linkTextKey === 'menu.searchPortal'
    );
    const otherItems = menus.filter(
        (item) => item.linkTextKey !== 'menu.searchPortal'
    );

    return (
        <>
            {/* Render all menu items except "suchportal" */}
            {otherItems.map((item) => {
                const { linkTextKey } = item;
                const icon = null;

                return (
                    <li
                        key={item.id}
                        className="nav-item"
                        style={{ fontSize: '16px' }}
                    >
                        <NavLink
                            exact={item.link === '/'} // Ensure exact match for the home link
                            to={item.link}
                            className="menu-dropdown nav-menu-link text-decoration-none"
                            data-toggle="dropdown"
                        >
                            {icon || t(linkTextKey)}
                            {linkTextKey === 'menu.projects' && (
                                <img
                                    src={polishGermanIcon}
                                    alt="Polish-German Icon"
                                    style={{
                                        marginLeft: '5px',
                                        height: '16px',
                                    }}
                                />
                            )}
                        </NavLink>
                    </li>
                );
            })}
            {/* Render the "suchportal" menu item with a search icon */}
            {suchportalItem && (
                <li key={suchportalItem.id} className="nav-item">
                    <NavLink
                        to={suchportalItem.link}
                        className="menu-dropdown nav-menu-link text-decoration-none"
                        data-toggle="dropdown"
                    >
                        <FontAwesome name="search" size="lg" />
                    </NavLink>
                </li>
            )}
        </>
    );
};

export default Dropdown;
